var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDivergentThinking = function SvgDivergentThinking(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 216,
    viewBox: "0 0 214 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Divergent_thinking"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Right-4",
    d: "M207.752 173.521H186.986C186.466 173.521 186.039 172.788 186.039 171.882V144.185C186.039 143.278 186.466 142.545 186.986 142.545H207.752C208.525 142.545 208.978 144.052 208.525 145.131L203.567 157.087C203.327 157.66 203.327 158.42 203.567 158.98L208.525 170.936C208.978 172.015 208.525 173.521 207.752 173.521Z",
    fill: "#4539FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Left-4",
    d: "M11.5268 142.559H32.293C32.8128 142.559 33.2393 143.292 33.2393 144.198V171.895C33.2393 172.802 32.8128 173.535 32.293 173.535H11.5268C10.7538 173.535 10.3006 172.028 10.7538 170.949L15.712 158.993C15.952 158.42 15.952 157.66 15.712 157.1L10.7538 145.144C10.3006 144.065 10.7538 142.559 11.5268 142.559Z",
    fill: "#4539FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back-4",
    filter: "url(#filter0_d_1241_129437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8822 58.0415V155.781C24.8822 161.992 28.8941 167.483 34.7987 169.376L102.922 191.195C105.747 192.101 108.8 192.101 111.625 191.195L179.748 169.376C185.653 167.483 189.665 161.992 189.665 155.781V58.0415C189.665 51.6837 185.466 46.0989 179.348 44.3262L111.226 24.6531C108.64 23.9067 105.894 23.9067 103.308 24.6531L35.1852 44.3262C29.0807 46.0856 24.8688 51.6837 24.8688 58.0415H24.8822Z",
    fill: "url(#paint0_linear_1241_129437)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Front-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.2137 61.8135V152.155C30.2137 158.273 34.1723 163.698 39.997 165.564L102.988 185.744C105.787 186.637 108.786 186.637 111.572 185.744L174.563 165.564C180.388 163.698 184.347 158.273 184.347 152.155V61.8135C184.347 55.549 180.202 50.0309 174.177 48.2849L111.186 30.0912C108.64 29.3581 105.921 29.3581 103.375 30.0912L40.3835 48.2849C34.3589 50.0309 30.2137 55.5357 30.2137 61.8135Z",
    fill: "url(#paint1_linear_1241_129437)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Base-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1241_129437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 29,
    width: 155,
    height: 158
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Front-8",
    d: "M30.2137 61.8135V152.155C30.2137 158.273 34.1723 163.698 39.997 165.564L102.988 185.744C105.787 186.637 108.786 186.637 111.572 185.744L174.563 165.564C180.388 163.698 184.347 158.273 184.347 152.155V61.8135C184.347 55.549 180.202 50.0309 174.177 48.2849L111.186 30.0912C108.64 29.3581 105.921 29.3581 103.375 30.0912L40.3835 48.2849C34.3589 50.0309 30.2137 55.5357 30.2137 61.8135Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1241_129437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M107.28 236.899C162.055 236.899 206.459 210.66 206.459 178.293C206.459 145.926 162.055 119.687 107.28 119.687C52.5052 119.687 8.10132 145.926 8.10132 178.293C8.10132 210.66 52.5052 236.899 107.28 236.899Z",
    fill: "#F28723"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Stars-4",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M66.0279 131.136C67.9271 131.136 69.4667 129.596 69.4667 127.697C69.4667 125.798 67.9271 124.258 66.0279 124.258C64.1287 124.258 62.5891 125.798 62.5891 127.697C62.5891 129.596 64.1287 131.136 66.0279 131.136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M168.206 122.859L166.206 126.138C165.9 126.644 165.153 126.644 164.833 126.138L162.834 122.859C162.674 122.606 162.674 122.286 162.834 122.019L164.833 118.74C165.14 118.234 165.886 118.234 166.206 118.74L168.206 122.019C168.366 122.272 168.366 122.606 168.206 122.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M174.63 115.795L173.057 118.367C172.817 118.767 172.231 118.767 171.978 118.367L170.405 115.795C170.285 115.595 170.285 115.341 170.405 115.141L171.978 112.569C172.218 112.169 172.804 112.169 173.057 112.569L174.63 115.141C174.75 115.341 174.75 115.595 174.63 115.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M85.5144 56.9351L84.3415 58.8411C84.1549 59.1344 83.7284 59.1344 83.5418 58.8411L82.3822 56.9351C82.2889 56.7885 82.2889 56.6019 82.3822 56.442L83.5418 54.536C83.7284 54.2427 84.1549 54.2427 84.3415 54.536L85.5144 56.442C85.6077 56.5886 85.6077 56.7752 85.5144 56.9351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M81.4759 50.4041L79.21 54.1094C78.8501 54.6826 78.0105 54.6826 77.6639 54.1094L75.398 50.4041C75.2247 50.1108 75.2247 49.751 75.398 49.4577L77.6639 45.7524C78.0238 45.1792 78.8635 45.1792 79.21 45.7524L81.4759 49.4577C81.6492 49.751 81.6492 50.1108 81.4759 50.4041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M50.22 120.593C51.177 120.593 51.9527 119.817 51.9527 118.86C51.9527 117.903 51.177 117.128 50.22 117.128C49.2631 117.128 48.4873 117.903 48.4873 118.86C48.4873 119.817 49.2631 120.593 50.22 120.593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M58.2573 136.054C59.6706 136.054 60.8164 134.908 60.8164 133.495C60.8164 132.082 59.6706 130.936 58.2573 130.936C56.8439 130.936 55.6981 132.082 55.6981 133.495C55.6981 134.908 56.8439 136.054 58.2573 136.054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M168.805 110.663L167.393 112.969C167.166 113.329 166.646 113.329 166.433 112.969L165.02 110.663C164.913 110.476 164.913 110.25 165.02 110.077L166.433 107.771C166.66 107.411 167.179 107.411 167.393 107.771L168.805 110.077C168.912 110.263 168.912 110.49 168.805 110.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M149.199 50.2441C150.546 50.2441 151.638 49.1521 151.638 47.805C151.638 46.4579 150.546 45.3658 149.199 45.3658C147.852 45.3658 146.76 46.4579 146.76 47.805C146.76 49.1521 147.852 50.2441 149.199 50.2441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M139.696 49.431C140.653 49.431 141.428 48.6553 141.428 47.6983C141.428 46.7413 140.653 45.9656 139.696 45.9656C138.739 45.9656 137.963 46.7413 137.963 47.6983C137.963 48.6553 138.739 49.431 139.696 49.431Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shine-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1241_129437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 166,
    height: 168
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M24.8822 58.1081V155.701C24.8822 161.952 28.9208 167.483 34.8654 169.389L102.895 191.182C105.747 192.101 108.813 192.101 111.665 191.182L179.695 169.389C185.653 167.483 189.678 161.952 189.678 155.701V58.1081C189.678 51.7103 185.44 46.0723 179.295 44.2996L111.265 24.6531C108.666 23.9067 105.894 23.9067 103.295 24.6531L35.2653 44.2996C29.1208 46.0723 24.8822 51.7103 24.8822 58.1081Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1241_129437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.15,
    d: "M16.3251 241.764C13.726 234.513 12.4198 230.421 9.82068 221.278C27.2413 208.349 45.9548 199.605 64.4817 188.596C84.0749 176.96 99.976 161.752 117.277 147.05C153.091 116.648 179.455 111.29 224.746 123.459C227.345 125.791 228.651 126.991 231.25 129.59C185.08 115.955 159.035 126.777 123.781 157.767C89.4596 187.956 48.6472 209.895 16.3117 241.751L16.3251 241.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.15,
    d: "M6.31524 225.596C-9.51925 197.526 -16.5568 164.444 -23.9409 133.482C23.4293 134.242 48.7271 110.49 83.5284 81.4599C119.049 51.8302 146.733 43.9796 190.998 58.6679C201.474 69.0776 211.524 79.314 221.254 90.4301C175.216 68.5711 145.214 98.494 113.785 130.629C79.783 165.404 41.6763 192.741 6.31524 225.596Z",
    fill: "white"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Arrows-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1241_129437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 29,
    width: 155,
    height: 158
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M30.0537 62.04V151.929C30.0537 158.18 34.0923 163.711 40.0502 165.617L102.908 185.704C105.761 186.61 108.813 186.61 111.665 185.704L174.523 165.617C180.481 163.711 184.52 158.18 184.52 151.929V62.04C184.52 55.6289 180.281 50.0042 174.124 48.2315L111.265 30.1178C108.666 29.3714 105.907 29.3714 103.308 30.1178L40.4501 48.2315C34.2922 50.0042 30.0537 55.6422 30.0537 62.04Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1241_129437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M129.019 197.246L112.772 124.285C112.718 124.138 112.692 123.992 112.692 123.845V73.3961C112.692 72.743 113.225 72.2099 113.878 72.2099H124.101C125.101 72.2099 125.647 71.0503 125.021 70.2772L108.027 49.5378C107.56 48.9646 106.667 48.9646 106.201 49.5378L89.2065 70.2772C88.5801 71.0503 89.1265 72.2099 90.1262 72.2099H100.349C101.002 72.2099 101.536 72.743 101.536 73.3961V123.845C101.536 123.992 101.509 124.152 101.456 124.285L101.216 125.351L85.2079 197.246C84.888 198.019 85.4612 198.872 86.3009 198.872H127.926C128.766 198.872 129.339 198.019 129.019 197.246Z",
    fill: "url(#paint2_linear_1241_129437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M162.621 197.593L125.434 123.699V123.365L147.866 85.3653C148.213 84.8055 148.932 84.6322 149.492 84.9788L158.196 90.3369C159.049 90.8567 160.115 90.1636 159.982 89.1773L156.396 62.5999C156.303 61.8535 155.543 61.4003 154.837 61.6402L129.499 70.3972C128.553 70.7171 128.42 71.9966 129.259 72.5164L137.963 77.8746C138.523 78.2211 138.696 78.9409 138.349 79.5007L114.145 123.432C114.105 123.579 114.025 123.712 113.931 123.832C113.931 123.832 127.247 187.13 130.246 196.287C130.752 197.819 132.178 198.859 133.791 198.859L161.075 198.806C161.875 199.059 162.674 198.433 162.621 197.593Z",
    fill: "url(#paint3_linear_1241_129437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M53.6588 197.593L88.66 123.699V123.365L67.4007 86.4982C67.0542 85.9517 66.3211 85.7784 65.7746 86.125L57.1109 91.5631C56.2712 92.0962 55.1783 91.4031 55.3116 90.4168L58.6571 63.8127C58.7504 63.0663 59.4968 62.5998 60.2032 62.8397L85.621 71.3568C86.5674 71.6767 86.714 72.9429 85.8743 73.476L77.2106 78.9142C76.6642 79.2607 76.4908 79.9938 76.8374 80.5402L99.9227 123.419C99.9627 123.565 100.043 123.699 100.136 123.819C100.136 123.819 86.9806 187.117 83.9683 196.273C83.4618 197.806 82.0356 198.846 80.4228 198.846L55.1783 198.792C54.3785 199.046 53.5788 198.419 53.6322 197.58L53.6588 197.593Z",
    fill: "url(#paint4_linear_1241_129437)"
  })))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M184.68 180.026C133.551 161.032 84.9679 161.059 33.8657 180.079C31.9864 180.865 29.8805 180.199 29.1474 178.546C26.7082 168.35 25.6019 163.205 23.6293 152.862C22.9362 151.196 24.1491 149.09 26.3484 148.223C81.7158 129.603 134.137 129.816 189.305 149.063C191.491 149.903 192.717 151.969 192.037 153.648C191.291 163.658 190.758 168.63 189.385 178.493C188.652 180.146 186.546 180.812 184.68 180.026Z",
    fill: "#4539FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M36.2649 159.873C37.0913 159.979 37.8243 160.299 38.4374 160.819C39.0506 161.339 39.5304 162.032 39.8503 162.898C40.1702 163.751 40.2635 164.591 40.1302 165.391C39.9969 166.19 39.6504 166.91 39.0906 167.537C38.5308 168.163 37.7977 168.643 36.878 168.976L33.5858 170.189L30.347 161.405L33.6391 160.193C34.5588 159.846 35.4385 159.739 36.2649 159.846V159.873ZM37.7044 165.831C37.9843 165.217 37.9843 164.511 37.691 163.711C37.3978 162.898 36.9313 162.352 36.3182 162.072C35.7051 161.792 34.9853 161.792 34.1856 162.099L33.1727 162.472L35.052 167.577L36.065 167.203C36.878 166.91 37.4245 166.457 37.7044 165.844V165.831Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M42.8493 157.06L45.715 165.964L43.5424 166.657L40.6768 157.753L42.8493 157.06Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M54.0454 153.821L53.3656 163.725L50.6199 164.498L44.9019 156.381L47.2344 155.727L51.3663 161.912L51.7129 154.475L54.032 153.821H54.0454Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M58.8171 154.568L59.2436 156.407L62.2159 155.714L62.6157 157.433L59.6434 158.127L60.1099 160.126L63.4688 159.339L63.8819 161.112L58.2972 162.418L56.1779 153.302L61.7626 151.995L62.1758 153.768L58.8171 154.554V154.568Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M70.8662 159.726L68.2938 156.621L67.7606 156.727L68.427 160.193L66.1878 160.619L64.4284 151.422L68.1871 150.703C68.9069 150.569 69.56 150.569 70.1064 150.729C70.6662 150.889 71.1194 151.156 71.4527 151.556C71.7859 151.942 72.0125 152.409 72.1191 152.955C72.239 153.568 72.1725 154.141 71.9192 154.688C71.666 155.234 71.2261 155.674 70.5863 155.994L73.3987 159.233L70.8662 159.713V159.726ZM67.454 155.141L68.8402 154.874C69.2534 154.794 69.5333 154.635 69.7066 154.395C69.8665 154.155 69.9198 153.848 69.8532 153.488C69.7866 153.142 69.6266 152.888 69.3867 152.715C69.1468 152.542 68.8136 152.515 68.4004 152.595L67.0142 152.862L67.454 155.141Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M80.796 151.662C80.5828 151.382 80.3162 151.182 79.9697 151.062C79.6364 150.942 79.2499 150.916 78.8367 150.982C78.1036 151.089 77.5571 151.409 77.1839 151.955C76.8107 152.502 76.6908 153.168 76.7974 153.968C76.9174 154.821 77.2506 155.461 77.7837 155.861C78.3169 156.274 78.9833 156.421 79.7964 156.301C80.3562 156.221 80.796 156.021 81.1426 155.674C81.4891 155.341 81.7024 154.888 81.809 154.341L78.9433 154.754L78.7034 153.088L83.6084 152.382L83.915 154.475C83.835 155.061 83.6217 155.621 83.2885 156.167C82.9553 156.714 82.5021 157.167 81.9289 157.553C81.3558 157.94 80.6761 158.193 79.903 158.3C78.9834 158.433 78.1436 158.353 77.3705 158.047C76.5975 157.753 75.9577 157.274 75.4512 156.62C74.9447 155.967 74.6248 155.181 74.5048 154.261C74.3849 153.342 74.4515 152.502 74.7581 151.729C75.0513 150.956 75.5312 150.316 76.1843 149.809C76.8374 149.303 77.6238 148.996 78.5435 148.863C79.6498 148.703 80.6228 148.837 81.4625 149.263C82.3022 149.69 82.9153 150.356 83.2885 151.276L80.796 151.636V151.662Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M87.9803 149.676L88.1668 151.556L91.2058 151.249L91.3791 152.995L88.3401 153.302L88.5401 155.341L91.9789 154.994L92.1654 156.807L86.4608 157.38L85.5278 148.063L91.2325 147.49L91.419 149.303L87.9803 149.65V149.676Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M102.855 156.141L100.576 156.274L96.444 150.729L96.7638 156.487L94.4847 156.62L93.9648 147.277L96.2441 147.144L100.376 152.715L100.056 146.931L102.335 146.797L102.855 156.141Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M111.985 146.664V148.49L109.533 148.517L109.613 156.047L107.334 156.074L107.254 148.543L104.774 148.57V146.744L111.999 146.664H111.985Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M125.021 147.104L124.927 148.93L122.448 148.81L122.088 156.327L119.809 156.221L120.169 148.703L117.69 148.583L117.783 146.757L125.007 147.104H125.021Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M135.51 148.037L134.631 157.354L132.365 157.14L132.725 153.302L129.193 152.968L128.833 156.807L126.567 156.594L127.446 147.277L129.712 147.49L129.366 151.142L132.898 151.476L133.244 147.824L135.51 148.037Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M140.602 148.703L139.389 157.98L137.123 157.687L138.349 148.41L140.615 148.703H140.602Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M150.119 159.699L147.866 159.313L145.08 152.982L144.107 158.673L141.855 158.287L143.428 149.063L145.68 149.45L148.466 155.807L149.439 150.089L151.691 150.476L150.119 159.699Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M157.863 161.365L155.69 156.647L154.797 160.686L152.571 160.193L154.61 151.062L156.836 151.556L155.943 155.567L159.875 152.235L162.488 152.822L157.956 156.514L160.582 161.992L157.863 161.392V161.365Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M167.059 154.021L164.687 163.072L162.488 162.498L164.86 153.448L167.059 154.021Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M175.137 166.124L172.951 165.457L170.978 158.833L169.312 164.351L167.126 163.685L169.832 154.728L172.018 155.394L173.99 162.045L175.67 156.501L177.856 157.167L175.15 166.124H175.137Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M185.506 162.992C185.453 162.645 185.306 162.338 185.066 162.072C184.827 161.805 184.507 161.605 184.107 161.459C183.414 161.206 182.774 161.232 182.187 161.539C181.601 161.845 181.174 162.378 180.908 163.138C180.615 163.951 180.601 164.658 180.881 165.271C181.161 165.884 181.681 166.324 182.441 166.604C182.961 166.79 183.454 166.817 183.92 166.684C184.373 166.55 184.787 166.257 185.133 165.817L182.414 164.831L182.987 163.258L187.652 164.938L186.932 166.937C186.586 167.417 186.133 167.817 185.586 168.136C185.04 168.456 184.427 168.656 183.734 168.736C183.04 168.803 182.334 168.71 181.601 168.443C180.735 168.123 180.028 167.657 179.482 167.03C178.935 166.404 178.602 165.684 178.469 164.871C178.335 164.058 178.415 163.218 178.735 162.352C179.055 161.485 179.522 160.779 180.148 160.233C180.775 159.686 181.494 159.353 182.307 159.206C183.12 159.073 183.96 159.153 184.827 159.473C185.88 159.859 186.679 160.432 187.212 161.192C187.746 161.952 187.972 162.845 187.879 163.831L185.506 162.978V162.992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1241_129437",
    x: 0.877182,
    y: 0.101608,
    width: 212.779,
    height: 215.765,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.9958
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129437"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129437",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1241_129437",
    x1: 107.28,
    y1: -13.2138,
    x2: 107.28,
    y2: -13.2138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1241_129437",
    x1: 107.28,
    y1: 252.747,
    x2: 107.28,
    y2: -51.2672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFAE4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF5696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1241_129437",
    x1: 107.107,
    y1: 49.0979,
    x2: 107.107,
    y2: 198.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#11C5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00D6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7D61FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1241_129437",
    x1: 167.766,
    y1: 65.548,
    x2: 125.817,
    y2: 196.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#11C5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00D6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7D61FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1241_129437",
    x1: 48.0703,
    y1: 66.5055,
    x2: 89.5929,
    y2: 196.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#11C5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00D6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7D61FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805FFF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDivergentThinking);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "divergent-thinking.78d1421.svg";